/**
 * A link card's picked ids: the ones in `listIds` in that order, then the
 * rest in their own order. A form that keeps its value this way is clean
 * again once an item is unpicked and picked back.
 */
export const orderLinkIds = (ids: string[], listIds: string[]): string[] => {
  const picked = new Set(ids);
  const known = listIds.filter((id) => picked.has(id));
  const knownIds = new Set(known);

  return [...known, ...[...picked].filter((id) => !knownIds.has(id))];
};
